import React from "react";

function FindMemberIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29.999"
      height="30"
      viewBox="0 0 29.999 30"
      {...props}
    >
      <path
        id="Path_410"
        data-name="Path 410"
        d="M97.348,125.943a4.922,4.922,0,0,0,1.211-1.028l7.662-7.662c.161-.161.264-.183.448-.037a11.212,11.212,0,0,0,5.24,2.3,11.863,11.863,0,1,0-5.534-20.866,11.78,11.78,0,0,0-3.75,5.439,11.86,11.86,0,0,0,1.864,10.958c.139.183.139.279-.029.448q-3.974,3.952-7.934,7.927a2.909,2.909,0,0,0-.756,1.005v.587a1.623,1.623,0,0,0,1,.939C96.959,125.943,97.157,125.943,97.348,125.943Zm16.558-8.749a9.369,9.369,0,1,1,9.343-9.409A9.372,9.372,0,0,1,113.906,117.194Z"
        transform="translate(-95.77 -95.95)"
        fill="currentColor"
      />
    </svg>
  );
}

export default FindMemberIcon;
